/* NPB homepage (2026 redesign): carousels, product tabs, header offset. Loaded on the homepage only. */
(function () {
  'use strict';

  /* Keep hero content clear of the transparent, absolutely positioned header. */
  function setHeaderOffset() {
    var section = document.getElementById('shopify-section-header');
    if (!section) return;
    /* On phones the theme positions the inner header on its own, so the section box can be
       shorter than what's drawn. Measure the lowest visible edge of the header instead. */
    var bottom = section.getBoundingClientRect().bottom;
    section.querySelectorAll('.announcement-bar, header.site-header, .site-header').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.bottom > bottom) bottom = r.bottom;
    });
    var h = Math.max(0, Math.round(bottom + window.scrollY - (section.getBoundingClientRect().top + window.scrollY)));
    document.documentElement.style.setProperty('--npbhp-header-h', h + 'px');
  }

  /* A carousel is any [data-npbhp-track] scroller with optional controls sharing a [data-npbhp-carousel] root. */
  function initCarousel(root) {
    if (root.__npbhp) return;
    root.__npbhp = true;
    var track = root.querySelector('[data-npbhp-track]');
    if (!track) return;
    var prev = root.querySelector('[data-npbhp-prev]');
    var next = root.querySelector('[data-npbhp-next]');
    var bar = root.querySelector('[data-npbhp-progress]');
    var controls = root.querySelector('[data-npbhp-controls]');

    function visibleTrack() {
      /* Product tabs keep several tracks; only the active one is visible. */
      var active = root.querySelector('[data-npbhp-track]:not([hidden])');
      return active || track;
    }

    function step(t) {
      var item = t.querySelector(':scope > *');
      /* Doctor pages are layout-only wrappers on desktop (display: contents): measure a card instead. */
      if (item && item.getBoundingClientRect().width === 0 && item.firstElementChild) item = item.firstElementChild;
      if (!item) return t.clientWidth;
      var gap = parseFloat(getComputedStyle(t).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function update() {
      var t = visibleTrack();
      var max = t.scrollWidth - t.clientWidth;
      var scrollable = max > 2;
      if (controls) controls.classList.toggle('is-static', !scrollable);
      if (prev) prev.disabled = !scrollable || t.scrollLeft <= 2;
      if (next) next.disabled = !scrollable || t.scrollLeft >= max - 2;
      if (bar) {
        var size = scrollable ? Math.max(t.clientWidth / t.scrollWidth, 0.12) : 1;
        var pos = scrollable ? (t.scrollLeft / max) * (1 - size) : 0;
        bar.style.width = (size * 100) + '%';
        bar.style.transform = 'translateX(' + (pos / size * 100) + '%)';
      }
    }

    if (prev) prev.addEventListener('click', function () {
      var t = visibleTrack();
      t.scrollBy({ left: -step(t), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      var t = visibleTrack();
      t.scrollBy({ left: step(t), behavior: 'smooth' });
    });

    root.querySelectorAll('[data-npbhp-track]').forEach(function (t) {
      t.addEventListener('scroll', update, { passive: true });
      enableMouseDrag(t);
    });
    window.addEventListener('resize', update);
    root.addEventListener('npbhp:refresh', update);
    update();
  }

  /* "Drag to explore" for mouse users; touch already scrolls natively. */
  function enableMouseDrag(t) {
    var down = false, startX = 0, startLeft = 0, moved = false;
    t.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = t.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      /* Only a real drag (more than 4px) switches the track into drag mode. Turning it on at
         pointerdown disabled pointer events on the cards for every press, so a plain click
         never reached the links and products could not be opened. */
      if (!moved && Math.abs(dx) > 4) { moved = true; t.classList.add('is-dragging'); }
      if (moved) t.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      t.classList.remove('is-dragging');
    });
    /* Swallow the click that ends a drag so cards don't navigate. */
    t.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    t.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function initTabs(root) {
    if (root.__npbhpTabs) return;
    root.__npbhpTabs = true;
    var tabs = root.querySelectorAll('[data-npbhp-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-npbhp-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        root.querySelectorAll('[data-npbhp-panel]').forEach(function (p) {
          var on = p.getAttribute('data-npbhp-panel') === id;
          p.hidden = !on;
          if (on) p.scrollLeft = 0;
        });
        root.dispatchEvent(new CustomEvent('npbhp:refresh'));
      });
      tab.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var list = Array.prototype.slice.call(tabs);
        var i = list.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
        var target = list[(i + list.length) % list.length];
        target.focus();
        target.click();
      });
    });
  }

  /* Core values (desktop): the photo is one composition (sky, bottle, woman), so the text and
     panel scale with the screen exactly like the photo does and keep the Figma 1600px layout. */
  function setValuesZoom() {
    var w = window.innerWidth;
    var z = w >= 1200 ? Math.min(2, Math.max(0.75, w / 1600)) : 1;
    document.documentElement.style.setProperty('--npbhp-values-zoom', z.toFixed(4));
  }

  function init(scope) {
    setValuesZoom();
    (scope || document).querySelectorAll('[data-npbhp-carousel]').forEach(initCarousel);
    (scope || document).querySelectorAll('[data-npbhp-tabs]').forEach(initTabs);
    setHeaderOffset();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  window.addEventListener('load', setHeaderOffset);
  window.addEventListener('resize', setHeaderOffset);
  window.addEventListener('resize', setValuesZoom);

  /* Re-initialise when sections are edited in the theme editor. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
